import loadable from '@loadable/component';

import LoadingPage from '../../../components/LoadingPage';

const LoadableCreateInvoicesPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableCreateInvoicesPage;
